import React, { useEffect, useState } from 'react';
import TrainingService from '../../Service/TrainingService';

const TrainingDuration = ({ training }) => {
    const [editMode, setEditMode] = useState(false);
    const [duration, setDuration] = useState('');
    const token = sessionStorage.getItem('token');

    // Set the initial duration value
    useEffect(() => {
        if (training.duree) {
            setDuration(training.duree); // Set the duration from training object
        }
    }, [training.duree]);

    const handleEditClick = () => {
        setEditMode(true);
    };

    const handleDurationChange = (event) => {
        setDuration(event.target.value); // Update duration when user types
    };

    const handleSaveClick = async () => {
        // Save the modified duration back to the training object
        training.duree = duration;

        try {
            let response;
            if (training.modif) {
                response = await TrainingService.putModifTraining(training);
            } else {
                response = await TrainingService.postModifTraining(training);
            }
            window.location.reload();
            console.log(response);
        } catch (error) {
            console.log("Error: " + error);
        }
        setEditMode(false); // Exit edit mode after saving
    };

    return (
        <div className="section-content">
            {editMode ? (
                <div>
                    {/* Edit mode: input for changing the duration */}
                    <label>Durée de la formation (heures):</label>
                    <input
                        type="number"
                        value={duration}
                        onChange={handleDurationChange}
                        style={{ width: '100%' }}
                    />
                </div>
            ) : (
                <p>Cette formation dure {duration} heures</p> // Display mode
            )}
            {editMode ? (
                <button
                    className="inscription-button modif_button"
                    onClick={handleSaveClick}
                    style={{ right: 0 }}
                >
                    Enregistrer
                </button>
            ) : (
                token === '' && (
                    <button
                        className="inscription-button modif_button"
                        onClick={handleEditClick}
                        style={{ marginLeft: '10px' }}
                    >
                        Modifier
                    </button>
                )
            )}
        </div>
    );
};

export default TrainingDuration;